import React from 'react'
import Detail from '../components/Detail';
import { useParams } from 'react-router';
import { sirketHaberleri } from '../data/sirket-haberleri';




const SirketHaberleriDetail = () => {


    const {id1} = useParams()

    const blog = sirketHaberleri.find(item => item.link === id1);




  return (
    <div><Detail blog={blog} id1={id1}/></div>
  )
}

export default SirketHaberleriDetail